<template>
  <div class="sms-left" :style="style">
    <div class="sms-left-header pa-3">
      <new-chat @click="click"></new-chat>
      <search @click="click"></search>
    </div>
    <v-divider></v-divider>
    <div class="sms-left-list">
      <v-list class="pa-0">
        <template v-for="(item, i) in list">
          <v-list-item
            link
            :key="i"
            :class="isActive(item) ? 'primary' : ''"
            :dark="isActive(item)"
            @click="click(item, false)"
          >
            <v-list-item-content>
              <v-list-item-title class="subtitle-2">
                <div class="flex-1 text-capitalize">
                  {{ item.name }}
                </div>
              </v-list-item-title>
              <v-list-item-subtitle class="body-2">
                <span class="text-capitalize">
                  {{ item.text }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="d-flex ml-1">
              <span class="caption pl-1">
                {{ $root.timeago(item.updated_at) }}
              </span>
              <v-btn
                icon
                color="red"
                x-small
                @click="remove(item, i)"
                v-if="isAdmin"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="'divider' + i"></v-divider>
        </template>
      </v-list>
      <infinite-loading
        ref="infinite"
        @infinite="infiniteHandler"
      ></infinite-loading>
      <confirm-delete ref="confirm"></confirm-delete>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { chat_list } from "../../assets/js/firebase";
import ConfirmDelete from "./ConfirmDelete.vue";
import NewChat from "./NewChat.vue";
import Search from "./Search.vue";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    InfiniteLoading,
    NewChat,
    Search,
    ConfirmDelete,
  },
  data() {
    return {
      lastDoc: null,
      search: "",
      active: {},
      unsubscribe: null,
      isMobile: window.innerWidth < 768,
      list: [],
    };
  },
  watch: {
    value(val) {
      this.active = val;
    },
    shouldRerender() {
      // Your re-render logic here
      const data = this.$store.state.shouldRerenderLeftComponent
      const index = this.list.findIndex(row => row.id == data.id)
      this.list[index].name = data.name
    }
  },
  computed: {
    style() {
      return {
        width: this.isMobile ? "100%" : "350px",
        borderWidth: this.isMobile ? "0px" : "1px",
      };
    },
    shouldRerender() {
      return this.$store.state.shouldRerenderLeftComponent;
    }
  },
  methods: {
    remove({ id }, i) {
      const vm = this;
      vm.$refs.confirm.init(id, i, "customer");
    },
    isActive({ id }) {
      return this.active.id === id;
    },
    unshift(item) {
      const vm = this;
      let index = vm.list.findIndex((doc) => {
        return item.id == doc.id;
      });
      if (index != -1) vm.list.splice(index, 1);
      vm.list.unshift(item);
    },
    click(item, isUnshift) {
      const vm = this;
      console.log(item);
      if (isUnshift != false) {
        vm.unshift(item);
      }
      if (vm.isMobile) {
        vm.$router.push({
          path: `/sms-view/${item.id}`,
          query: {
            name: item.name,
            phone: item.phone,
          },
        });
      } else {
        vm.$router.push({
          path: `/sms`,
          query: {
            id: item.id,
            name: item.name,
            phone: item.phone,
          },
        });
      }
    },
    async infiniteHandler($state) {
      const vm = this;
      try {
        let query = chat_list.orderBy("updated_at", "desc");
        if (vm.lastDoc !== null) query = query.startAfter(vm.lastDoc);
        let snap = await query.limit(20).get();
        if (snap.docs.length < 20) $state.complete();
        if (snap.docs.length === 0) {
          if ($state !== null) $state.complete();
        } else {
          snap.docs.forEach((item) => {
            let doc = item.data();
            doc.id = item.id;
            vm.list.push(doc);
            vm.lastDoc = item;
          });
          if (vm.list.length <= 20) {
            vm.$emit("init", vm.list[0]);
          }
          if ($state !== null) $state.loaded();
        }
        if (vm.unsubscribe === null) {
          vm.listen();
        }
      } catch (e) {
        vm.$root.alert(e.message, "Alert");
        if ($state !== null) $state.complete();
      }
    },

    listen() {
      const vm = this;
      let query = chat_list.orderBy("updated_at", "desc").limit(1);
      vm.unsubscribe = query.onSnapshot((snap) => {
        let list = [];
        vm.list.forEach((item) => {
          list.push(item);
        });
        snap.docs.forEach((doc) => {
          let index = -1;
          let data = doc.data();
          data.id = doc.id;
          list.forEach((item, i) => {
            if (item.id === doc.id) index = i;
          });
          if (index === -1) {
            list.unshift(data);
          } else {
            list[index] = data;
          }
        });
        list.sort(function (a, b) {
          var c = new Date(a.updated_at);
          var d = new Date(b.updated_at);
          return d - c;
        });
        vm.list = list;
      });
    },
  },
  beforeDestroy() {
    if (this.unsubscribe !== null) this.unsubscribe();
  },
};
</script>

<style lang="scss">
.sms {
  &-left {
    background: white;
    width: 350px;
    height: calc(100vh - 67px);
    overflow-y: auto;
    border-right: 1px solid lightgray;
  }
}
</style>
